import { Injectable, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WorkflowOrigin } from '@warema/shared/models';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SunCenterService {
    private readonly _activatedRoute = inject(ActivatedRoute);

    public isSunCenter$ = new BehaviorSubject<boolean>(false);
    public sunCenterLang$ = new BehaviorSubject<string>('de');

    constructor() {
        this._activatedRoute.queryParams.subscribe(params => {
            const langQueryParam = params['language'] as string;
            if (langQueryParam) {
                this.sunCenterLang$.next(langQueryParam);
            }

            const originQueryParam = params['origin'] as WorkflowOrigin;
            const isSunCenter = !!(originQueryParam && originQueryParam === WorkflowOrigin.SunCenter);
            this.isSunCenter$.next(isSunCenter);
        });
    }
}
